import { Button, IconButton, InputAdornment, OutlinedInput, Stack } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState } from "react";
import { borderStyle, defaultGap, tinyGap } from "../../../styles/consts";
import NotImplemented from "../utils/NotImplemented";

export default function SearchBar({
  type,
  onSearch,
  notImplemented = false,
  setLoadingData,
  disabled = false,
  disabledMessage,
}: {
  type: string;
  onSearch: (searchQuery: string) => void;
  notImplemented?: boolean;
  setLoadingData?: any;
  disabled?: boolean;
  disabledMessage?: string;
}) {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = async () => {
    if (disabled) return;
    setLoadingData(true);

    await onSearch(searchQuery);

    setLoadingData(false);
  };

  const handleEnterClick = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // Handle clearing the search input
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchQuery(newValue);

    // If the input is cleared, immediately trigger the search to remove the filter
    if (newValue === "" && searchQuery !== "") {
      onSearch("");
    }
  };

  const handleClear = () => {
    setSearchQuery("");
    onSearch("");
  };

  return (
    <Stack
      sx={{
        borderBottom: borderStyle,
        width: "100%",
        padding: defaultGap,
        boxSizing: "border-box",
        flexShrink: 0,
      }}
    >
      <Stack sx={{ flexDirection: "row" }}>
        <OutlinedInput
          id="search-bar"
          fullWidth
          value={searchQuery}
          onChange={handleInputChange}
          onKeyDown={handleEnterClick}
          autoComplete="off"
          disabled={disabled}
          placeholder={disabled && disabledMessage ? disabledMessage : undefined}
          endAdornment={
            searchQuery ? (
              <InputAdornment position="end" sx={{ mr: 0.5 }}>
                <IconButton
                  size="small"
                  onClick={handleClear}
                  edge="end"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null
          }
          sx={{
            borderRadius: "0",
            height: defaultGap,
          }}
        />
        {notImplemented ? (
          <NotImplemented popupLeft>
            <Button
              variant="primary"
              sx={{
                padding: `${tinyGap} ${defaultGap}`,
              }}
            >
              Search {type}
            </Button>
          </NotImplemented>
        ) : (
          <Button
            variant="primary"
            id="search-button"
            onClick={handleSearch}
            disabled={disabled}
            sx={{
              padding: `${tinyGap} ${defaultGap}`,
            }}
          >
            Search {type}
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
